import { getSupabase } from './client.js';
import { unwrap } from './errors.js';

export async function fetchMyMemberships() {
  return unwrap(await getSupabase().rpc('my_memberships')) ?? [];
}

export async function fetchMyPermissions(orgId) {
  return unwrap(await getSupabase().rpc('my_permissions', { p_org: orgId })) ?? [];
}

export async function fetchMyProfile(userId) {
  return unwrap(await getSupabase().from('profiles').select('id, email, full_name, avatar_path, theme').eq('id', userId).single());
}

/** Best-effort: client-reported session events are audit hints, never a reason to block the user. */
export async function recordSessionEvent(event) {
  try { await getSupabase().rpc('record_session_event', { p_event: event }); } catch { /* ignore */ }
}
